import { BaseJs } from '@gate31/core/src/libs/BaseJsComponents';
import { Base } from '@gate31/core/src/libs/BaseComponent';
import { CustomCn } from '@gate31/core/src/libs/classname';
import LiquidRender, { LiquidTemplates } from '@gate31/uikit/common/scripts/liquid-render';
import EventBus from 'EventBus';
import Products from 'Products';
import Cart from 'Cart';
import { Modal, ModalOpts } from '../Modal/Modal';

export class CardSetModalForm extends BaseJs {
    private cn: CustomCn;
    productFormCn: CustomCn;

    template: keyof LiquidTemplates;
    modalTemplate: ModalOpts['template'];
    whenOpenModal?: (product: unknown) => void
    whenCloseModal?: () => void;

    modal: Modal

    constructor(options: {
        template: keyof LiquidTemplates;
        modalTemplate: ModalOpts['template'];
        cn: CustomCn;
        productFormCn: CustomCn;
        whenOpenModal?: (product: unknown) => void;
        whenCloseModal?: () => void;
    }) {
        super(options.template);
        this.cn = options.cn;
        this.productFormCn = options.productFormCn;
        this.template = options.template;
        this.modalTemplate = options.modalTemplate;
        this.whenOpenModal = options.whenOpenModal;
        this.whenCloseModal = options.whenCloseModal;

        Products.setConfig({
            options: {
                default: 'option-radio',
                Размер: 'option-radio'
            },
            initOption: false,
            decimal: 0
        });

        EventBus.subscribe('add_items:insales:cart', (data: any) => {
            if (! data.action.form) {
                return;
            }

            this.modal.close();
        });

        document.addEventListener('click', e => {
            const target = e.target as HTMLElement;
            const button = target.closest('.JsTrigger_CardSetModalForm');

            if (button) {
                const ids = button.getAttribute('data-products-ids')?.split(',').map(id => id.trim()) || [];

                Products.getList(ids)
                    .then(response => Object.entries(response).map(([ _, value ]) => value))
                    .then(products => {
                        this.showModal({
                            products,
                            whenOpenModal: async () => {
                                await Products.getList(ids); // Хак благодаря которому корректно погрудаются опции продукта
                                this.whenOpenModal?.(products);

                                // eslint-disable-next-line
                                new CardSetForm({
                                    node: CardSetForm.querySelector(this.cn?.toSelector()),
                                    cn: this.cn,
                                    productFormCn: this.productFormCn,
                                    whenAddToCard: () => {
                                        this.modal.close();
                                        this.whenCloseModal?.()
                                    },
                                    whenGoToChackout: () => {
                                        this.modal.close();
                                        this.whenCloseModal?.()
                                        window.location.href = 'https://gate31.ru/cart_items';
                                    }
                                });
                            }
                        });
                    });
            }
        });
    }

    getModalContent(products: any): string {
        return LiquidRender.render(this.template, {
            products
        });
    }

    showModal(options: { products: any; whenOpenModal?: () => void }) {
        this.modal = new Modal({
            template: this.modalTemplate,
            content: this.getModalContent(options.products),
            disableBodyScroll: false,
            viewOpts: {
                closeIconSize: 'm',
                className: this.cn.toString()
            }
        });

        this.modal.open(options.whenOpenModal);
    }
}

class CardSetForm extends Base<HTMLDivElement> {
    cn: CustomCn;
    productFormCn: CustomCn;

    forms: NodeListOf<HTMLFormElement>
    buttonAddToCard: HTMLElement | null;
    buttonGoToCheckout: HTMLElement | null;

    whenAddToCard?: () => void;
    whenGoToChackout?: () => void;

    // Флаг - былали попытка отправить форму
    isFilthy: boolean;
    // Мапа - валидации формы
    formValidateMap: Map<HTMLElement, boolean>;

    constructor(options: { node: HTMLDivElement; cn: CustomCn; productFormCn: CustomCn; whenAddToCard?: () => void; whenGoToChackout?: () => void }) {
        super(options.node);

        this.cn = options.cn;
        this.productFormCn = options.productFormCn;
        this.isFilthy = false;

        this.whenAddToCard = options.whenAddToCard;
        this.whenGoToChackout = options.whenGoToChackout;

        this.forms = document.querySelectorAll(this.cn.setElem('form').toSelector());

        this.buttonAddToCard = document.querySelector(this.cn.setElem('btn-cart').toSelector());
        this.buttonGoToCheckout = document.querySelector(this.cn.setElem('btn-order').toSelector());

        this.formValidateMap = new Map<HTMLElement, boolean>();

        this.forms?.forEach(el => {
            this.formValidateMap.set(el, false);
        });

        EventBus.subscribe('update_variant:insales:product', () => {
            if (! this.isFilthy) {
                return;
            }

            this.forms.forEach(form => {
                this.processOneForm(form);
            });
        });

        this.buttonGoToCheckout?.addEventListener('click', () => {
            const valid = this.whenClickButton();

            if (valid) {
                this.whenGoToChackout?.();
            }
        });

        this.buttonAddToCard?.addEventListener('click', () => {
            const valid = this.whenClickButton();

            if (valid) {
                this.whenAddToCard?.();
            }
        });
    }

    whenClickButton() {
        this.isFilthy = true;

        this.forms.forEach(form => {
            this.processOneForm(form);
        });

        const valid = this.checkValidSet();

        if (valid) {
            const variants = this.getSelectedVariants();

            Cart.add({
                items: Object.fromEntries(variants.map(item => [ item, 1 ]))
            });
        }

        return valid;
    }

    getSelectedVariants(): number[] {
        const selectedVariants: number[] = [];

        this.forms.forEach(form => {
            const product = JSON.parse(form.getAttribute('data-product') || '{}');
            const variants = product.variants;

            const optionsWrapperNodes = form.querySelectorAll(this.productFormCn.setElem('size-wrap').toSelector());

            const selecteOptions: string[] = [];

            optionsWrapperNodes.forEach(wrap => {
                const input = wrap?.querySelector('input:checked');
                const optionsId = input?.getAttribute('data-option-id');
                const optionsValueId = input?.getAttribute('data-value-id');

                const option = Object.values(product.options).find((item: any) => item.id === Number(optionsId)) as any;
                const optionValues = option?.values;
                const optionValue = Object.values(optionValues).find((item: any) => item.id === Number(optionsValueId)) as any;

                selecteOptions.push(optionValue.title);
            });

            const variantTitle = selecteOptions.join(' / ');
            const variantId = variants.find((item: any) => item.title === variantTitle)?.id;

            selectedVariants.push(variantId);
        });

        return selectedVariants;
    }

    checkValidSet(): boolean {
        const arr: Array<boolean | undefined> = [];

        this.forms.forEach(form => {
            arr.push(this.formValidateMap.get(form));
        });

        return arr.filter(Boolean).length === this.forms.length;
    }

    processOneForm(form: HTMLFormElement) {
        const sizeErrorMessage = form.querySelector(this.cn.setElem('not-use-size-message').toSelector());
        const checkedSize = form.querySelector(this.productFormCn.setElem('razmer-btns').toSelector())?.querySelector('input:checked');

        this.formValidateMap.set(form, Boolean(checkedSize));

        if (! checkedSize) {
            sizeErrorMessage?.classList.add(this.cn.setElem('not-use-size-message').setMode({ active: true }).toString());
        } else {
            sizeErrorMessage?.classList.remove(this.cn.setElem('not-use-size-message').setMode({ active: true }).toString());
        }
    }
}
